import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNow, isToday } from 'date-fns';
import { isNilOrEmpty } from 'helpers';
/*
 * Returns a date string relative to the current time
 * "10 hours ago", "1 week ago"
*/
@Pipe({ name: 'relativeDate' })
export class RelativeDatePipe implements PipeTransform {
  transform(value: any): string {
    if (isNilOrEmpty(value)) {
      return null;
    }

    try {
      const asDate = new Date(value);
      if (isToday(asDate)) {
        return 'today';
      }
      return formatDistanceToNow(asDate, {addSuffix: true});
    } catch (e) {
      console.error(e);
    }
  }
}
